import { Box, Stack, Typography } from '@mui/material';
import WarningAmberIcon from '@mui/icons-material/WarningAmber';
import { isStagingEnvironment } from '../../utils/environment';

const EnvironmentBanner = () => {
  if (!isStagingEnvironment()) return null;

  return (
    <Box
      data-testid="environment-banner"
      sx={(theme) => ({
        position: 'sticky',
        top: 0,
        zIndex: theme.zIndex.drawer + 2,
        bgcolor: 'warning.main',
        color: 'warning.contrastText',
        borderBottom: '1px solid rgba(6, 37, 34, 0.24)',
        boxShadow: '0 10px 24px -18px rgba(6, 37, 34, 0.55)',
      })}
    >
      <Stack
        direction="row"
        alignItems="center"
        justifyContent="center"
        spacing={1}
        sx={{
          minHeight: 38,
          px: { xs: 1.5, sm: 2 },
          py: 0.75,
          textAlign: 'center',
        }}
      >
        <WarningAmberIcon fontSize="small" />
        <Typography
          variant="body2"
          sx={{
            fontWeight: 900,
            lineHeight: 1.2,
            letterSpacing: 0,
            textTransform: 'uppercase',
          }}
        >
          Environnement de preproduction
        </Typography>
      </Stack>
    </Box>
  );
};

export default EnvironmentBanner;
